<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle title="UPA" description="" url="/dashboard" />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link
            :to="{
              path: item.link,
              query: item.ajudaKey ? { ajudaKey: item.ajudaKey } : {},
            }"
          >
            <div class="item">
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img
                v-else-if="item.imagem !== ''"
                :src="item.imagem !== '' ? item.imagem : ''"
                alt=""
              />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import Acompanhamento from '@/components/icons/VinculoAcompanhamento/Acompanhamento.vue'
import ExportarBpa from '@/components/icons/BpaRaas/ExportarBpa.vue'

export default {
  name: 'Upa',
  metaInfo: {
    title: 'UPA',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    Acompanhamento,
    ExportarBpa,
  },
  computed: {
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.upa
      ) {
        const bpaErasClone = [...this.$store.state.permissoes.upa]
        return bpaErasClone.sort((a, b) => a.ordem - b.ordem)
      }
      return []
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
